<script lang="ts" setup>
import { useUserStore } from '@/stores/user';
import { useModalsStore } from '@/stores/modals';
import { useAlertsStore } from '@/stores/alerts';
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import { useRouter } from 'vue-router';

import { useForm } from 'vee-validate';
import * as yup from 'yup';

import formAlerts from '@/components/form-alerts/form-alerts.vue';

const { status } = storeToRefs(useUserStore());
const { recoverPassword } = useUserStore();
const { toggleModal, closeModal } = useModalsStore();
const { openMessage } = useAlertsStore();
const router = useRouter();

let formAlert = ref();
const emit = defineEmits(['onSubmit']);
const props = defineProps<{
    page: boolean;
}>();

const activeValidation = ref(false);
const validate = computed(() => {
    return yup.object({
        email: yup.string().required().email()
    });
});

const { errors, useFieldModel, handleSubmit } = useForm({
    validationSchema: validate
});
const [email] = useFieldModel(['email']);

const onSubmit = handleSubmit(async (values, { resetForm }) => {
    emit('onSubmit', true);
    const error = await recoverPassword(values.email);
    emit('onSubmit', false);
    activeValidation.value = false;
    if (error) {
        resetForm();
        await formAlert.value.addMsg({type: 'error', content: 'modals.alerts.errorRecoverPassword'});
    } else {
        resetForm();
        await formAlert.value.addMsg({type: 'success', content: 'modals.alerts.successRecoverPassword'});

        router.push({ name: 'grid' });
        closeModal('lostpassword');
    }
});
</script>

<template src="./modal-lostpassword.html"></template>
